import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getPlatformUsage} from './getPlatformUsage';

export const platformUsageQueryOptions = (period: string) =>
  queryOptions({
    queryKey: keys.usage.platform(period),
    queryFn: () => getPlatformUsage(period),
  });
